import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "switch col s7" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "lever" }, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons right" }, "equalizer", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", null, [
      _createTextVNode(" Hide "),
      _createElementVNode("input", {
        type: "checkbox",
        onInput: $setup.updateShowEqualizer
      }, null, 32 /* HYDRATE_EVENTS */),
      _hoisted_2,
      _createTextVNode(" Show ")
    ]),
    _hoisted_3
  ]))
}